import React, { useState } from 'react';
import { useAuth } from './hooks/useAuth';
import Login from './pages/Login';
import Home from './pages/Home';
import Scan from './pages/Scan';
import Review from './pages/Review';
import Destino from './pages/Destino';
import Sucesso from './pages/Sucesso';
import TopBar from './components/TopBar';
import BottomNav from './components/BottomNav';
import { logout } from './services/api';
import './App.css';

export default function App() {
  const { user, loading } = useAuth();
  const [tab, setTab] = useState('home');
  const [flow, setFlow] = useState(null);
  const [scanData, setScanData] = useState(null);
  const [reviewData, setReviewData] = useState(null);
  const [successData, setSuccessData] = useState(null);

  if (loading) return <div className="app-loading"><div className="app-spinner" /></div>;
  if (!user) return <Login />;

  const handleScanResult = (data) => { setScanData(data); setFlow('review'); };
  const handleReviewConfirm = (data) => { setReviewData(data); setFlow('destino'); };
  const handleSuccess = (data) => { setSuccessData(data); setFlow('sucesso'); };

  const resetFlow = () => {
    setFlow(null); setScanData(null); setReviewData(null); setSuccessData(null); setTab('home');
  };

  const handleTabChange = (newTab) => {
    if (newTab === 'scan') { setFlow('scan'); setTab('scan'); }
    else { resetFlow(); setTab(newTab); }
  };

  const getTitle = () => {
    if (flow === 'review') return 'Verificar';
    if (flow === 'destino') return 'Enviar para';
    if (flow === 'sucesso') return 'Entregue';
    return null;
  };

  const getBackHandler = () => {
    if (flow === 'review') return () => setFlow('scan');
    if (flow === 'destino') return () => setFlow('review');
    return null;
  };

  const showBottomNav = !flow || flow === 'scan';
  const inScan = flow === 'scan' || (tab === 'scan' && !['review','destino','sucesso'].includes(flow));

  return (
    <div className="app">
      <TopBar user={!flow ? user : null} onLogout={logout} title={getTitle()} onBack={getBackHandler()} />
      <main className="app-main">
        {tab === 'home' && !flow && <Home user={user} onScan={() => handleTabChange('scan')} />}
        {inScan && <Scan onResult={handleScanResult} />}
        {flow === 'review' && <Review scanData={scanData} onConfirm={handleReviewConfirm} onBack={() => setFlow('scan')} />}
        {flow === 'destino' && <Destino reviewData={reviewData} onSuccess={handleSuccess} onBack={() => setFlow('review')} />}
        {flow === 'sucesso' && <Sucesso result={successData} onNovaScan={resetFlow} />}
      </main>
      {showBottomNav && <BottomNav active={tab} onChange={handleTabChange} />}
    </div>
  );
}
